export default __webpack_public_path__ + "static/media/hockey3.3fef13dd.png";